import { ScrollView } from 'devextreme-react/scroll-view';
import './info.scss';

const InfoPage = () => {
  return (
    <ScrollView>
      <div className="content-block">
        <div className="dx-card responsive-paddings">
          <h3>Preis- & Konditionsinformationen</h3>
          <p>
            Unsere regulären Preise gelten Montag bis Freitag von 07:00 Uhr bis 18:00 Uhr. Für Transporte außerhalb dieser Zeiten (ab 18:00 Uhr, an Wochenenden sowie an Feiertagen) wird ein Zuschlag von 50 % auf den Netto-Preis berechnet.
          </p>

          <h3>Stornierungen & Terminverschiebungen</h3>
          <p>
            Stornierungen oder Terminverschiebungen sind bis spätestens 12 Stunden vor dem vereinbarten Abholtermin kostenfrei möglich.
          </p>
          <p>
            Bei kurzfristigen Absagen oder Verschiebungen innerhalb von 12 Stunden vor dem geplanten Termin berechnen wir eine Bereitschafts- & Stornopauschale in Höhe von <strong>29,95 € netto</strong>.
          </p>
          <p>
            Bei bereits gestarteter Anfahrt, bereits vor Ort befindlichem Fahrer oder geplanten Touren über 20 km wird die ursprünglich geplante Tour gemäß vereinbartem Tourpreis berechnet.
          </p>

          <h3>Wartezeitregelung</h3>
          <p>
            Die ersten 15 Minuten gelten als kostenfreie Kulanzzeit. Sollte das Fahrzeug innerhalb dieser Zeit nicht übergabebereit sein, wird die gesamte Wartezeit ab Beginn der Standzeit mit <strong>9,95 € je angefangene 15 Minuten</strong> berechnet.
          </p>

          <h3>Express- & Prioritätspauschale</h3>
          <p>
            Für Touren mit weniger als 6 Stunden Vorlaufzeit sowie für Touren, die nach 18:00 Uhr für den folgenden Werktag eingestellt werden, berechnen wir eine Express- & Prioritätspauschale in Höhe von <strong>14,95 € netto</strong>.
          </p>

          <h3>Hinweis</h3>
          <p>
            Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer. Es gelten die jeweils aktuellen Preislisten und Vereinbarungen.
          </p>
        </div>
      </div>
    </ScrollView>
  );
};

export default InfoPage;